import { Component, input } from '@angular/core'

@Component({
  template: `
    <p>{{ api().message | translate }}</p>

    <input
      #passwordInput
      name="cancellationReason"
      class="input__field"
      type="password"
      (input)="setPassWord(passwordInput.value)"
    />
    /><br /><br />

    <app-button
      [fullWidth]="false"
      text="blue"
      label="Enter"
      [disabled]="!this.password"
      (click)="dismiss(false)"
    />
    <app-button
      [fullWidth]="false"
      text="blue"
      label="I forgot my password"
      (click)="dismiss(true)"
    />
  `,
  styleUrls: ['../../../scss/_input.scss'],
  standalone: false,
})
export class LinkAccountComponent {
  protected api = input.required<{
    message: string
    getAccountPassword: (pw: string) => Promise<string>
    forgotPassword: (forgotPassword: boolean) => Promise<boolean>
  }>()

  public password = ''

  public setPassWord(val: string): void {
    this.password = val
  }

  public async dismiss(forgotPassword: boolean): Promise<string | boolean | undefined> {
    if (!forgotPassword) {
      return await this.api().getAccountPassword(this.password)
    }
    return await this.api().forgotPassword(forgotPassword)
  }
}
